import { createAction, props } from "@ngrx/store";
import { Resolution } from "../models/PollChoice";

export const creationAction = createAction("init action");

export const setTitleAction = createAction('Change title', props<{title: string}>())
export const setLiveResolutionsAction = createAction('Change live resolutions', props<{resolutions: Resolution}>())
